import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
  const fetchBlog = async () => {
    try {
      // ✅ FIXED ENDPOINT
      const res = await fetch(`https://thakkar-backend.vercel.app/api/blog/${id}`);

      if (!res.ok) {
        throw new Error("Blog not found");
      }

      const data = await res.json();

      if (data.success) {
        setBlog(data.data); // MongoDB blog
      }
    } catch (error) {
      console.error("Failed to fetch blog", error);
    }
  };

  fetchBlog();
}, [id]);


  if (!blog)
    return (
      <p className="text-center mt-32 text-gray-500">
        Loading blog...
      </p>
    );

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4 mt-32">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow overflow-hidden">

        <img
          src={blog.image}
          alt={blog.title}
          className="h-80 w-full object-cover"
        />

        <div className="p-8">
          <div className="flex gap-6 text-sm text-gray-500 mb-3">
            <span>{blog.date}</span>
            <span>{blog.readTime}</span>
          </div>

          <h1 className="text-3xl font-bold mb-4">
            {blog.title}
          </h1>

          <p className="text-gray-700 leading-relaxed whitespace-pre-line">
            {blog.content}
          </p>
        </div>

      </div>
    </div>
  );
};

export default BlogDetails;
